import { supabase } from '../lib/supabaseClient';

// Maximum concurrent saves per user. Mirrored by a DB trigger (SETUP-ACCOUNT.sql).
export const SAVE_LIMIT = 3;

// All calls run as the logged-in user against the GAME project. RLS limits
// every query to the user's own rows, so most selects need no explicit filter.

// ── DoF profile ──────────────────────────────────────────────────────────
export async function getMyProfile() {
  return supabase.from('profiles').select('*').maybeSingle();
}

export async function saveMyProfile(userId, data) {
  return supabase
    .from('profiles')
    .upsert({ id: userId, data, updated_at: new Date().toISOString() })
    .select()
    .maybeSingle();
}

// ── Saves (appointments) ─────────────────────────────────────────────────
export async function listSaves() {
  return supabase.from('saves').select('*').order('last_played_at', { ascending: false });
}

export async function getSave(id) {
  return supabase.from('saves').select('*').eq('id', id).maybeSingle();
}

export async function createSave(clubId, name) {
  // user_id defaults to auth.uid() in the DB.
  const row = { club_id: clubId };
  if (name) row.name = name;
  return supabase.from('saves').insert(row).select().maybeSingle();
}

export async function renameSave(id, name) {
  return supabase.from('saves').update({ name }).eq('id', id);
}

export async function touchSave(id) {
  return supabase
    .from('saves')
    .update({ last_played_at: new Date().toISOString() })
    .eq('id', id);
}

export async function deleteSave(id) {
  return supabase.from('saves').delete().eq('id', id);
}

// ── Achievements ─────────────────────────────────────────────────────────
// Definitions live in achievementsData.js; this table only records unlocks.
export async function listUnlockedAchievements() {
  return supabase.from('achievement_unlocks').select('key, unlocked_at');
}

export async function unlockAchievement(key) {
  // user_id defaults to auth.uid(); ignore if already earned.
  return supabase
    .from('achievement_unlocks')
    .upsert({ key }, { onConflict: 'user_id,key', ignoreDuplicates: true });
}

// ── Announcements (broadcast) ────────────────────────────────────────────
export async function listAnnouncements() {
  return supabase
    .from('announcements')
    .select('*')
    .eq('published', true)
    .order('pinned', { ascending: false })
    .order('created_at', { ascending: false });
}
